var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6087 2.78261H15.5217L14.3696 1.04348C13.9348 0.391304 13.1739 0 12.3913 0H7.6087C6.82609 0 6.06522 0.391304 5.63043 1.04348L4.47826 2.78261H2.3913C1.06522 2.78261 0 3.84783 0 5.17391V13.6087C0 14.9348 1.06522 16 2.3913 16H17.6087C18.9348 16 20 14.9348 20 13.6087V5.17391C20 3.84783 18.9348 2.78261 17.6087 2.78261ZM10.0001 14.0434C7.02181 14.0434 4.60876 11.6304 4.60876 8.65214C4.60876 5.67388 7.02181 3.28257 10.0001 3.28257C12.9783 3.28257 15.3914 5.69561 15.3914 8.67388C15.3914 11.6304 12.9783 14.0434 10.0001 14.0434ZM17.2174 6.15219H17.3044C17.6957 6.13045 17.9783 5.80436 17.9566 5.41306C17.9348 5.02176 17.6087 4.71741 17.2174 4.73915H16.3479C15.9783 4.76089 15.6957 5.0435 15.6739 5.41306C15.6522 5.80436 15.9566 6.13045 16.3479 6.15219H17.2174Z",
    fill: "#2B323B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.67383C8.34783 5.67383 7 7.02165 7 8.67383C7 10.326 8.34783 11.6521 10 11.6521C11.6522 11.6521 13 10.3043 13 8.65209C13 6.99992 11.6522 5.67383 10 5.67383Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.263c0cda53890879702df87098d79013.svg";
export { ForwardRef as ReactComponent };